import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { debounceTime, filter } from 'rxjs/operators';

const NOTIFICATION_SHOWN_TIME = 3 * 1000;

interface Notification {
    shown?: boolean;
    status?: string;
    message?: string;
}

const notificationState: Notification = {
    shown: false,
    status: null,
    message: null
};

const notification = new BehaviorSubject<Notification>(notificationState);

@Injectable()
export class NotificationService {
    public notification = notification;
    public changes = this.notification.asObservable()
        .pipe(
            debounceTime(NOTIFICATION_SHOWN_TIME),
            filter((val) => val.shown)
        )
        .forEach((val) => {
            this.turnNotification({ shown: false });
        });

    public turnNotification(changes: Notification) {
        const newState = { ...this.notification.value, shown: true, ...changes };
        this.notification.next(newState);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts